import React, { useContext, useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import { styles } from '../PrintFormStructure.styles';
import { Box } from '@material-ui/core';
import clsx from 'clsx';
import MessagesContext from '../../../../../../contexts/messagesContext';
import { getFullDate } from '../../../../../../utils/dateTimeUtil';
import { GENDERS, MARITAL_STATUSES } from '../HeaderForm';
import { ReactComponent as SquareIcon } from '../../../../../../assets/images/Icon/square.svg';
import { ReactComponent as CheckedSquareIcon } from '../../../../../../assets/images/Icon/check-square.svg';
import { getClinicId, getNamespace } from '../../../../../../utils/storage';

const Header = ({ values }) => {
    const { messages } = useContext(MessagesContext);
    const clinicId = getClinicId();
    const namespaceId = getNamespace();
    const userInfo = useSelector((state) => state.user.userInfo);
    const formStructure = useSelector((state) => state.dynamicForms.formStructure);
    const isRtl = formStructure?.presentation?.rtl;
    const classes = styles({ rtl: isRtl });

    const [namespaceIcon, clinicIcon] = useMemo(() => {
        const namespace = userInfo?.namespaces.find((n) => n.id === namespaceId);
        const clinic = namespace?.access.clinics.find((c) => c.id === clinicId);
        return [namespace?.logo, clinic?.logo];
    }, [clinicId, namespaceId, userInfo]);

    const renderSectionContent = (label, value) => {
        return (
            <>
                <Box className={classes.label}>{messages[label]}:</Box>
                <Box className={classes.value}>{value}</Box>
            </>
        );
    };

    const renderCheckboxContent = (label, value, options) => {
        return (
            <>
                <Box className={classes.label}>{messages[label]}:</Box>
                <Box className="d-flex">
                    {options.map((option, index) => (
                        <Box key={index} className={classes.option}>
                            <Box>
                                {value === option.value ? <CheckedSquareIcon /> : <SquareIcon />}
                            </Box>
                            <Box className={classes.optionLabel}>{messages[option.label]}</Box>
                        </Box>
                    ))}
                </Box>
            </>
        );
    };

    return (
        <>
            <div className={classes.header}>
                <img alt="clinic icon" className={classes.headerIcon} src={clinicIcon} />
                <Box />
                <Box>
                    <h4 className={classes.ministryFaText}>وزارت بهداشت درمان و آموزش پزشکی</h4>
                    <h4 className={classes.ministryText}>Ministry of Health & Medical Education</h4>
                </Box>
                <Box />
                <img alt="namespace icon" className={classes.headerIcon} src={namespaceIcon} />
            </div>

            <Box className={classes.grid}>
                <Box className={clsx(classes.gridItem, 'border-bottom-0')}>
                    {renderSectionContent('unitNumber', values.admission_id)}
                </Box>
                <Box
                    className={clsx(classes.gridItem, 'border-0')}
                    style={{ gridColumn: 'auto / span 3' }}
                >
                    <h5 className={classes.title}>{values.title}</h5>
                </Box>
                <Box className={clsx(classes.gridItem, 'border-bottom-0')}>
                    {renderSectionContent('NID', values.national_id)}
                </Box>
                {/* **************** */}
                <Box className={clsx(classes.gridItem, 'border-bottom-0')}>
                    {renderSectionContent('lastName', values.last_name)}
                </Box>
                <Box
                    className={clsx(
                        classes.gridItem,
                        'border-right-0 border-left-0 border-bottom-0'
                    )}
                >
                    {renderSectionContent('name', values.first_name)}
                </Box>
                <Box
                    className={clsx(classes.gridItem, 'border-bottom-0 border-left-0')}
                    style={{ gridColumn: 'auto / span 2' }}
                >
                    {renderSectionContent('ward', values.ward)}
                </Box>
                <Box className={clsx(classes.gridItem, 'd-flex border-bottom-0')}>
                    <Box className="flex-1">{renderSectionContent('room', values.room)}</Box>
                    <Box className="flex-1">{renderSectionContent('bed', values.bed)}</Box>
                </Box>
                {/* ************* */}
                <Box className={clsx(classes.gridItem, 'border-bottom-0')}>
                    {renderSectionContent('fatherName', values.fatherName)}
                </Box>
                <Box
                    className={clsx(
                        classes.gridItem,
                        'border-right-0 border-left-0 border-bottom-0'
                    )}
                >
                    {renderSectionContent('birthDate', getFullDate(values.birthDate))}
                </Box>
                <Box
                    className={clsx(classes.gridItem, 'border-bottom-0 border-left-0')}
                    style={{ gridColumn: 'auto / span 2' }}
                >
                    {renderSectionContent('attendingPhysician', values.attendingPhysician)}
                </Box>
                <Box className={clsx(classes.gridItem, 'border-bottom-0')}>
                    {renderSectionContent('admissionDate', getFullDate(values.admissionDate))}
                </Box>
                {/* *********** */}
                <Box className={clsx(classes.gridItem)}>
                    {renderCheckboxContent('gender', values.gender, GENDERS)}
                </Box>
                <Box className={clsx(classes.gridItem, 'border-left-0 border-right-0')}>
                    {renderCheckboxContent('maritalStatus', values.maritalStatus, MARITAL_STATUSES)}
                </Box>
                <Box className={clsx(classes.gridItem)} style={{ gridColumn: 'auto / span 2' }}>
                    {renderSectionContent('occupation', values.occupation)}
                </Box>
                <Box className={clsx(classes.gridItem, 'border-right-0')}>
                    {renderSectionContent('dischargDate', getFullDate(values.dischargDate))}
                </Box>
            </Box>
        </>
    );
};

Header.propTypes = {
    values: PropTypes.object
};

export default Header;
